import { type Common } from '../common.js';
import { type Nullable } from '../models/common.js';
import {
  type Preference,
  type PreferenceDetail,
  type PreferenceOptions,
} from '../models/user/preferences.js';

export class API {
  common: Common;
  baseEndpoint = '/users';

  constructor(common: Common) {
    this.common = common;
  }

  async get(args: { userId: string; includePreferenceDescriptions: boolean }): Promise<{
    preferences: PreferenceDetail;
    preferenceDescriptions?: PreferenceOptions;
  }> {
    const { userId, includePreferenceDescriptions } = args;
    let url = this.common.constructPath(`${this.baseEndpoint}/${userId}/preferences`);
    if (includePreferenceDescriptions) {
      url = `${url}?includePreferenceDescriptions=true`;
    }

    return await this.common.getJSON(url);
  }

  async set(
    userId: string,
    values: Nullable<PreferenceDetail>
  ): Promise<{ preferences: PreferenceDetail }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${userId}/preferences`);
    return await this.common.patchJSON(url, {
      preferences: values,
    });
  }

  async findOneByUserId(userId?: string): Promise<Preference> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${userId}/preferences/full`);
    return await this.common.getJSON(url);
  }
}
